import { Warrants } from '@factorin/domain';

import { get, post, withUrl, Request } from '../rest';


type Download =
    Request.DownloadProgress &
    Request.Cancel & {
        id: string;
    };

type WarrantRequest = Pick<Warrants.Warrant, 'Kind' | 'Number' | 'StartDate' | 'WarrantLocation'>;

type CreateSign = {
    DocumentForSignUid: string;
    Signature: string;
    WarrantRequest: WarrantRequest;
}

type RelatedSignRequest = {
    parentSignature: CreateSign;
    childSignatures: CreateSign[];
}

type MultiSignRequest = {
    signatures: CreateSign[];
}

const signsPart = withUrl('signs');
const multiSignsPart = withUrl('multiSigns');

export const signs = {
    download: get<Download>(
        ({ id, ...request }) => signsPart({
            path: `${id}`,
            responseType: 'blob',
            ...request,
        }),
    ),

    create: post<CreateSign, void>(
        data => signsPart({
            body: data,
        }),
    ),

    relatedSigns: post<RelatedSignRequest, void>(
        ({ parentSignature, childSignatures }) => multiSignsPart({
            body: {
                ParentSignature: parentSignature,
                ChildSignatures: childSignatures,
            },
        }),
    ),

    multiSigns: post<MultiSignRequest, void>(
        ({ signatures }) => signsPart({
            path: 'list',
            body: {
                Signatures: signatures,
            },
        }),
    ),
};
